import * as React from 'react';
import customSolarIconWrapper from '../../../custom-icons';

// Placed on the shared 240x240 doodle frame: stack a body, eyes, mouth and accessory to compose a doodle
const DoodleMouthBouche9 = customSolarIconWrapper(<g transform="translate(108 148)">
	<path d="M8.87934 33.179C23.6997 30.418 28.6984 11.619 17.2229 1.80059C14.0657 -0.900514 9.32694 -0.519216 6.63814 2.65248C3.94934 5.82408 4.32894 10.585 7.48604 13.286C9.33644 14.869 8.53034 17.901 6.14054 18.346C2.06314 19.106 -0.628963 23.042 0.127237 27.138C0.883537 31.234 4.80184 33.939 8.87934 33.179Z" fill="#202020" />
</g>, { viewBox: '0 0 240 240' });

export default DoodleMouthBouche9;
